import React from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";

const formatDateTime = (value) => {
  if (!value) return "—";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "—";
  return parsed.toLocaleString();
};

const RecordMetadataSection = ({ record, sx = {} }) => {
  if (!record) return null;

  const createdByName = record.createdByName || record.uploadedByName || "—";
  const updatedByName = record.updatedByName || createdByName || "—";

  return (
    <Box sx={{ mt: 2, ...sx }}>
      <Divider sx={{ mb: 2 }} />
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        Record Information
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography variant="caption" color="text.secondary">
            Created By
          </Typography>
          <Typography variant="body2">{createdByName}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="caption" color="text.secondary">
            Created At
          </Typography>
          <Typography variant="body2">{formatDateTime(record.createdAt)}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="caption" color="text.secondary">
            Updated By
          </Typography>
          <Typography variant="body2">{updatedByName}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="caption" color="text.secondary">
            Updated At
          </Typography>
          <Typography variant="body2">{formatDateTime(record.updatedAt)}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RecordMetadataSection;
